var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('checklist.sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"titleImg":_vm.$store.getters.systemTitleImage,"title":_vm.$store.getters.systemTile}},[_c('template',{slot:"links"},[_vm._l((_vm.process),function(p){return _c('div',{key:p.Id},[(_vm.getPermission(p.permission))?_c('div',[_c('sidebar-item',{ref:"sidebarItemForms",refInFor:true,attrs:{"link":{
              name: `${p.displayName}`,
              icon: 'tim-icons icon-chart-pie-36'
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: `Kanban`,
                path: `/workflow/kanban/${p.displayName}/${p.id}`
              }}}),(
                (_vm.$store.getters.companyId == 1 && p.id == 173) ||
                  (_vm.$store.getters.companyId == 398 && p.id == 13)
              )?_c('sidebar-item',{attrs:{"link":{
                name: `Preenchidos`,
                path: `/workflow/filled/shlog/${p.displayName}/${p.id}`
              }}}):_c('sidebar-item',{attrs:{"link":{
                name: `Preenchidos`,
                path: `/workflow/filled/${p.displayName}/${p.id}`
              }}}),(_vm.$store.getters.companyId == 398 && p.id == 13)?_c('sidebar-item',{attrs:{"link":{
                name: `Status das viagens`,
                path: `/shlog/tripStatus/`,
                icon: 'tim-icons icon-chart-pie-36'
              }}}):_vm._e(),(_vm.$store.getters.companyId == 398 && p.id == 13)?_c('sidebar-item',{attrs:{"link":{
                name: `Status da frota`,
                path: `/shlog/fleet/status/list/`,
                icon: 'tim-icons icon-chart-pie-36'
              }}}):_vm._e(),(_vm.$store.getters.companyId == 398 && p.id == 13)?_c('sidebar-item',{attrs:{"link":{
                name: `Monitoramento logístico`,
                path: `/shlog/monitoramentoLogistico/`,
                icon: 'tim-icons icon-chart-pie-36'
              }}}):_vm._e()],1)],1):_vm._e()])}),(
          _vm.$store.getters.companyId == 1 || _vm.$store.getters.companyId == 398
        )?_c('sidebar-item',{attrs:{"link":{
          name: `Frete Rápido`,
          icon: 'tim-icons icon-chart-pie-36'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: `NF-e Solicitações de Coleta`,
            path: `/shlog/freteRapido/solicitacaoColeta/nfe/`
          }}})],1):_vm._e(),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('workflow.process'),
          icon: 'tim-icons icon-notes'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('workflow.create'),
            path: '/workflow/Create'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('workflow.processList'),
            path: '/workflow/processList'
          }}})],1),(_vm.isAccessVehicles)?_c('sidebar-item',{ref:"sidebarItemPendencies",attrs:{"link":{
          name: 'Equipamentos',
          icon: 'tim-icons icon-delivery-fast'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Equipamento',
            path: '/workflow/vehicleRegistration/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Marca de Equipamento',
            path: '/workflow/brandVehicle/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Modelo de Equipamento',
            path: '/workflow/vehicleModel/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Tipo do Equipamento',
            path: '/workflow/vehicleType/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Ativar/Desativar',
            path: '/workflow/vehicleAvailableReason/list'
          }}})],1):_vm._e(),(_vm.isAccessTripPlan)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('tripPlan.plural'),
          path: '/workflow/pathList',
          icon: 'tim-icons icon-square-pin'
        }}}):_vm._e(),(_vm.isAccessTripPlan)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('tripPlan.waypoints'),
          path: '/workflow/waypointList',
          icon: 'tim-icons icon-pin'
        }}}):_vm._e(),(_vm.isUserViewer)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.usuarios'),
          path: '/workflow/user/list',
          icon: 'tim-icons icon-single-02'
        }}}):_vm._e(),(_vm.isProfileViewer)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.profile.sidebar'),
          path: '/workflow/profile/all',
          icon: 'tim-icons icon-single-02'
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.sector'),
          path: '/workflow/sector/all',
          icon: 'tim-icons icon-vector'
        }}}),(_vm.isMasterAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.module.sidebar'),
          path: '/workflow/module/all',
          icon: 'tim-icons icon-components'
        }}}):_vm._e(),(
          _vm.$store.getters.isAdminRms == true ||
            _vm.$store.getters.companyId == 1 ||
            _vm.$store.getters.companyId == 177
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.empresas'),
          path: '/workflow/company/all',
          icon: 'tim-icons icon-bank'
        }}}):_vm._e(),(_vm.$store.getters.isAdminRms == true || _vm.isCompanyViewer == true)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.costCenterTitle'),
          path: '/workflow/costCenter/list',
          icon: 'tim-icons icon-money-coins'
        }}}):_vm._e(),(_vm.$store.getters.isAdminRms == true)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.systemIntegration.sidebar'),
          path: '/workflow/systemIntegration/all',
          icon: 'tim-icons icon-single-02'
        }}}):_vm._e()],2)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"trackingShippingCompany"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }